<!--
 * @Author: Dzy
 * @Date: 2022-11-11 14:11:15
 * @LastEditors: Dzy
 * @LastEditTime: 2023-02-17 10:18:59
 * @Description: 自定义表格组件
-->
<template>
  <div class="my-table">
    <a-table v-bind="$attrs" :pagination="false" @change="emitChangeSort">
      <template v-if="props.showTitle" #title>
        <slot name="tableTitle"></slot>
      </template>
      <template #bodyCell="{ column, record, text, index }">
        <template v-if="column.showTip">
          <ADLTableTooltip 
            :content="text" 
            :offset-height="column.offsetHeight || 66"
          />
        </template>
        <!-- <template v-else>
          {{ text }}
        </template> -->
        <slot name="tableBody" :column="column" :record="record" :text="text" :index="index"></slot>
      </template>
    </a-table>
    <a-row v-if="pagination" justify="space-between" align="middle" class="my-pagination">
      <a-col>
        <a-checkbox v-if="cheackBox" @change="emitCheckedAll">{{t('from.全选（跨页）')}}</a-checkbox>
        <span class="totalData">{{t('from.共计{total}条数据',{total})}}</span>
      </a-col>
      <a-col>
        <a-row justify="end" align="middle">
          <a-pagination
            v-model:current="current"
            v-model:pageSize="pageSize"
            :total="total"
            :showQuickJumper="true"
            :showSizeChanger="false"
            :size="size"
            @change="emitChangeTable"
          />
          <a-select
            style="margin-left: 16px; width: auto"
            :size="size"
            v-model:value="pageSize"
            @change="changePageSize"
          >
            <a-select-option :value="10">10 {{t('from.条')}}/{{t('from.页')}}</a-select-option>
            <a-select-option :value="20">20 {{t('from.条')}}/{{t('from.页')}}</a-select-option>
            <a-select-option :value="50">50 {{t('from.条')}}/{{t('from.页')}}</a-select-option>
            <a-select-option :value="80">80 {{t('from.条')}}/{{t('from.页')}}</a-select-option>
          </a-select>
        </a-row>
      </a-col>
    </a-row>
  </div>
</template>
<script setup>
import { toRefs, ref } from 'vue'
import { useI18n } from 'vue-i18n'

const { t, locale } = useI18n()

const props = defineProps({
  cheackBox: [Boolean],
  pagination: [Object, Boolean],
  size: {
    type: String,
    default: 'default'
  },
  showTitle: [Boolean]
})

const emit = defineEmits(['change'])

const { current, pageSize, total, field, order } = toRefs(props.pagination)

const emitCheckedAll = (e) => {
  emit('cheack', {
    checkedAll: e.target.checked,
  })
}

const emitChangeTable = () => {
  emit('change', {
    current: current?.value,
    pageSize: pageSize?.value,
    field: field?.value,
    order: order?.value
  })
}

const changePageSize = () => {
  current.value = 1
  emit('change', {
    current: current?.value,
    pageSize: pageSize?.value,
    field: field?.value,
    order: order?.value
  })
}

const emitChangeSort = (pag, filters, sorter) => {
  field && (field.value = sorter.field)
  order && (order.value = sorter.order)
  emit('change', {
    current: current?.value,
    pageSize: pageSize?.value,
    field: field?.value,
    order: order?.value
  })
}
</script>

<style lang="less" scoped></style>
